import storage from 'redux-persist/lib/storage'
import {ReduxReducerPersistConfig} from '../../lib/redux/ReduxReducer'

export const REDUX_PERSIST_CONFIG: ReduxReducerPersistConfig = {
  key: 'root',
  storage,
  whitelist: [
    'userState',
    'lastPaymentMethodState',
    'versionState',
    'transactionState',
  ],
}
